import { Stack, Typography } from '@mui/material'
import { BrandLogo, useOrganizationContent } from '@cibo/profile'
import { useProgramConfig } from '../../queries'

type ProgramSponsorDisplayProps = {
  programId: string
}

export const ProgramSponsorDisplay = ({ programId }: ProgramSponsorDisplayProps) => {
  const config = useProgramConfig({ programId })

  const program = config.data?.program
  const contentfulOrgId = program?.sponsorOrg?.contentfulOrgId

  const content = useOrganizationContent({ contentfulOrgId })

  if (!config.isFetched || !contentfulOrgId) return null

  return (
    <Stack>
      <BrandLogo variant="square" size="small" contentfulOrgId={contentfulOrgId} />
      <Typography variant="caption">{content.data?.fields.name}</Typography>
    </Stack>
  )
}
